/***************************************************************************************************
** logConstituentActivity
***************************************************************************************************/

export default async function logConstituentActivity(url, options = {}) {
  if (!url) throw new Error("URL is required!");

  const description = options.description || url;
  const activityType = options.activityType || "load_page ";
  const referrerDescription = options.referrer || "Website ";

  if (!window.appContext) throw new Error("App context is missing!");
  if (window.appContext.isImpersonation) return;

  /**************************************************************************************************/

  try {
    const response = await fetch("/constituent-activity-logs", {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Cache-Control": "no-cache, no-store",
        "Authorization-Token": window.appContext.authorizationToken,
        "X-CSRF-Token": window.appContext.authenticityToken,
      }),
      body: JSON.stringify({
        household_id: window.appContext.householdId,
        person_id: window.appContext.personId,
        log_type: activityType,
        description: description,
        context: description,
        referrer_description: referrerDescription,
        url: url,
      }),
    });

    if (!response.ok) throw new Error(response.statusText);

    return true;
  } catch (error) {
    console.error("Error logging activity:", error);
    return false;
  }
}
